<template>
  <div>
    <div
      class="header__artwork--wrapper"
      :style="{
        backgroundColor: `rgb(${$root.content.allImages[$root.content.backgroundTile].colors.DarkVibrant._rgb.join()})`,
        backgroundImage: `url(${$root.content.allImages[$root.content.backgroundTile].Img200})`,
        boxShadow: `0 4px 36px -8px rgba(${$root.content.allImages[$root.content.backgroundTile].colors.DarkVibrant._rgb.join()}, 1)`,
      }"
    >
      <div class="logo__wrapper">
        <game-of-thrones-logo v-if="hasScrolledIn" />
        <!-- <game-of-thrones-logo v-else /> -->
      </div>

      <div class="header__wrapper">
        <h2 v-balancetext class="title">{{ $root.content.header.title }}</h2>
        <p
          v-balancetext
          v-for="(par, i) of $root.content.header.intro"
          :key="`main-intro-${i}`"
          class="intro"
        >
          {{ par }}
        </p>
      </div>

      <hr class="whiteRule" />

      <section class="options__wrapper">
        <!-- voting buttons -->
        <theme-row
          v-for="theme in $root.content.themes"
          :key="`theme-row-${theme}`"
          :theme="theme"
          @vote="handleVote"
          @unvote="handleUnVote"
        />
      </section>
    </div>
    <!-- <simple-title :header="$root.content.header" /> -->


    <div
      v-if="message"
      class="noResults__wrapper"
    >
      <p class="noResults__message" >{{ message }}</p>
    </div>

    <section class="showcard__wrapper">
      <!-- matched shows -->
      <show-card
        v-for="(match, i) in matches"
        :key="`match-${match.TITLE}-${i}`"
        :show="match"
        :votes="Object.keys(votes)"
      />
    </section>

  </div>
</template>


<script>
import SimpleTitle from '@/components/headers/simple-title.vue'
import ThemeRow from '@/components/got-show-matcher/theme-row.vue'
import ShowCard from '@/components/got-show-matcher/show-card.vue'
import GameOfThronesLogo from '@/components/logos/game-of-thrones.vue'

import debounce from '@/functions/debounce'

export default {
  name: 'got-show-finder',
  props: {},
  components: {
    SimpleTitle,
    ThemeRow,
    ShowCard,
    GameOfThronesLogo,
  },
  data () {
    return {
      votes: {},
      matches: [],
      message: null,
      cardWidths: [],
      cardWidth: null,
      hasScrolledIn: false,
    }
  },
  methods: {
    updateMatches () {
      if (Object.keys(this.votes).length) {
        this.matches = this.$root.content.parts
          .filter(part => {
            return Object.keys(this.votes)
              .every(vote => {
                if (this.votes[vote] === -1) {
                  return !(part[vote] === 1)
                } else if (this.votes[vote] === 0) {
                  return true
                }
                return part[vote] === 1
              })
          })
        if (!this.matches.length && Object.keys(this.votes).length > 0) {
          this.message = 'No matching shows, try a different combination'
        } else {
          this.message = null
        }
        return
      } else {
        this.message = this.$root.content.messages.start
      }
      this.matches = []
    },
    handleUnVote (content) {
      const { theme } = content
      this.votes = Object.keys(this.votes)
        .filter(v => v !== theme)
        .reduce((output, vote) => {
          const update = output
          update[vote] = this.votes[vote]
          return update
        }, {})
      this.updateMatches()
    },
    handleVote (vote) {
      this.votes[vote.theme] = vote.value
      this.updateMatches()
      ga('send', 'event', {
        // hitType: 'event',
        eventCategory: `Theme selected ${vote.value > 0 ? 'show' : 'hide'}`,
        eventAction: `theme-selected-${vote.value > 0 ? 'show' : 'hide'}`,
        eventLabel: `${vote.theme}__${vote.value}`,
      })
    },
    // cardwidth (w) {
    //   this.cardWidths.push(w)
    //   this.cardWidth = 600 // Math.min(...this.cardWidths)
    // },
    checkScrollPosition () {
      // const { scrollY } = window
      debounce(() => {
        const posY = this.$el.getBoundingClientRect().top
        if (posY < (window.innerHeight * 0.9)) {
          this.hasScrolledIn = true
          window.removeEventListener('scroll', this.checkScrollPosition)
        }
      }, 32)()
    },
  },
  computed: {},

  mounted () {
    this.$nextTick(() => {
      this.message = this.$root.content.messages.start
      if (this.$el.getBoundingClientRect().top < window.innerHeight * 0.9) {
        this.hasScrolledIn = true
      } else {
        window.addEventListener('scroll', this.checkScrollPosition)
      }
    })
  },
}
</script>


<style scoped lang="sass">
@import index


.options__wrapper
  display: flex
  flex-wrap: wrap
  justify-content: center
  // display: grid
  // grid-template-columns: repeat(auto-fill, minmax(120px, 1fr))
  grid-gap: 8px
  text-align: center


.showcard__wrapper
  // display: flex
  // flex-wrap: wrap
  // justify-content: center
  display: grid
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr))

.noResults
  &__wrapper
    padding: 16px 0
  &__message
    text-align: center
    font-size: 24px
    color: $color-grey-4


.header__artwork--wrapper
  position: relative
  background-size: 200px 200px
  background-repeat: repeat
  padding: 32px
  margin-bottom: 32px
  display: grid
  text-align: center
  border-radius: 8px
  .title
    // color: white
    font-size: 36px
    text-align: center
    color: gold
    background: -webkit-linear-gradient(gold, darkorange)
    -webkit-background-clip: text
    -webkit-text-fill-color: transparent
  .intro
    color: white
    text-align: center
    font-size: 16px !important

  .logo__wrapper
    margin-bottom: 32px
  
  &:after 
    content: url('../content/images/news-foxtel.png')
    position: absolute
    bottom: 10px
    right: 10px
    width: 257px
    height: 31px

.header__wrapper
  margin-bottom: 24px

.whiteRule
  border-color: rgba(white, 0.2)
  margin-bottom: 40px


</style>



// WEBPACK FOOTER //
// src/layouts/NED-0534-got-show-matcher.vue